import React, { useState } from "react";
import { Table, Button, Icon } from "semantic-ui-react";
import { map } from "lodash";
import { QRCodeSVG } from "qrcode.react";
import { ModalBasic } from "../../../Common";
import { useTable } from "../../../../hooks";
import { getTableKind } from "../../../../utils/constants";
import { getTablePlace, getTableShortName } from "../../../../utils/table";
import "./TableTablesAdmin.scss";

export function TableTablesAdmin(props) {
  const { tables, updateTable, deleteTable, onRefetch } = props;
  const [showModal, setShowModal] = useState(false);
  const [qrTable, setQrTable] = useState(null);

  const openCloseModal = () => setShowModal((prev) => !prev);

  const showQr = (table) => {
    setQrTable(table);
    openCloseModal();
  };

  return (
    <>
      <Table className="table-tables-admin">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Mesa</Table.HeaderCell>
            <Table.HeaderCell>Ambiente / tipo</Table.HeaderCell>
            <Table.HeaderCell>Código</Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {map(tables, (table, index) => (
            <Table.Row key={index}>
              <Table.Cell>
                <strong>{getTablePlace(table)}</strong>
                {table.kind !== "SALON" && (
                  <div className="table-tables-admin__internal">Nº interno {table.number}</div>
                )}
              </Table.Cell>
              <Table.Cell>
                {table.kind === "SALON" ? (
                  table.area_name || "—"
                ) : (
                  <>
                    <Icon name={getTableKind(table.kind).icon} /> {getTableKind(table.kind).text}
                  </>
                )}
              </Table.Cell>
              <Table.Cell>
                {table.kind === "SALON" ? <code>{table.access_code}</code> : "—"}
              </Table.Cell>

              <Actions
                table={table}
                updateTable={updateTable}
                deleteTable={deleteTable}
                showQr={showQr}
              />
            </Table.Row>
          ))}
        </Table.Body>
      </Table>

      <ModalBasic
        show={showModal}
        onClose={openCloseModal}
        title="Codigo QR"
        size="mini"
      >
        {qrTable && (
          <TableQr
            key={qrTable.id}
            table={qrTable}
            onCodeChanged={onRefetch}
          />
        )}
      </ModalBasic>
    </>
  );
}

// QR de la mesa con su código de acceso (`?k=`). El código también se imprime
// debajo, para quien no pueda escanear y lo escriba a mano en la pantalla de
// inicio. "Regenerar código" invalida el QR impreso actual (hay que
// reimprimirlo) — para cuando el código de una mesa se filtró.
function TableQr(props) {
  const { table, onCodeChanged } = props;
  const { regenerateTableCode } = useTable();
  const [code, setCode] = useState(table.access_code);
  const [confirming, setConfirming] = useState(false);

  const url = `${window.location.origin}/client/${table.number}?k=${code}`;

  const onRegenerate = async () => {
    const updated = await regenerateTableCode(table.id);
    if (updated?.access_code) {
      setCode(updated.access_code);
      if (onCodeChanged) onCodeChanged();
    }
    setConfirming(false);
  };

  return (
    <div className="table-qr">
      {/* El adhesivo lleva el ambiente aunque sea el único, y el número de la mesa
          en grande: quien lo pega y quien lo lee no se confunden. */}
      {table.area_name && <p className="table-qr__area">{table.area_name}</p>}
      <h3 className="table-qr__title">
        {getTableShortName(table)}
      </h3>
      <QRCodeSVG value={url} />
      <p className="table-qr__code">
        Código: <strong>{code}</strong>
      </p>

      {confirming ? (
        <div className="table-qr__confirm">
          <p>
            El QR impreso de esta mesa dejará de funcionar y habrá que
            reimprimirlo. ¿Continuar?
          </p>
          <Button size="small" onClick={() => setConfirming(false)}>
            Cancelar
          </Button>
          <Button size="small" negative onClick={onRegenerate}>
            Sí, regenerar
          </Button>
        </div>
      ) : (
        <Button
          size="small"
          basic
          className="table-qr__regenerate"
          onClick={() => setConfirming(true)}
        >
          <Icon name="refresh" /> Regenerar código
        </Button>
      )}
    </div>
  );
}

function Actions(props) {
  const { table, updateTable, deleteTable, showQr } = props;

  return (
    <Table.Cell textAlign="right">
      {/* Las mesas virtuales no llevan QR: sus pedidos los registra el mozo. */}
      {table.kind === "SALON" && (
        <Button icon onClick={() => showQr(table)}>
          <Icon name="qrcode" />
        </Button>
      )}

      <Button icon onClick={() => updateTable(table)}>
        <Icon name="pencil" />
      </Button>

      <Button icon negative onClick={() => deleteTable(table)}>
        <Icon name="close" />
      </Button>
    </Table.Cell>
  );
}
